<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 16:53:09
 * @LastEditTime: 2019-08-26 18:03:51
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <!--<el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
      <el-form-item label="添加时间" style="text-align: center">
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="开始时间"
            v-model="form.start"
            style="width: 100%"
          ></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="结束时间"
            v-model="form.end"
            style="width: 100%"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="经销商编号:">
        <el-input v-model="form.dealer_sn" clearable></el-input>
      </el-form-item>
      <el-form-item label="经销商名称:">
        <el-input v-model="form.dealer_name" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch()">搜索</el-button>
        {{ expense_num_list1 }}
      </el-form-item>
    </el-form>
    -->
    <!--表格-->
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      v-loading="loading"
      height="350"
      style="width: 100%"
    >
      <el-table-column prop="gift_img" label="礼品图片">
        <template slot-scope="scope">
          <div>
            <img
              :src="scope.row.img_path + scope.row.gift_img"
              height="100"
              width="100"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="number" label="礼品编号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="gift_name" label="礼品名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="expense_num" label="未申报数量" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.expense_num }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="操作" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button type="primary" @click="confirm(scope.row)">申请报销</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[5, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    >
    </el-pagination>
    <!--报销明细-->
    <selectDealerExpenseDetail
      :detailData="salesman_id"
      @update-message="updateMessage"
      v-if="selectDED"
      v-on:handleClose="selectDED = false"
    />
  </div>
</template>

<script>
import selectDealerExpenseDetail from "@/common/selectDealerExpenseDetail";
export default {
  name: "dealerexpenselistmanage",
  data() {
    return {
      salesman_id: "", //查看申报明细传递经销商业务员编号
      selectDED: false,
      loading: false,
      deliverDialog: false,
      form: {
        region_city: "",
        region_province: "",
        region_city: "",
        region_country: "",
        store_img: [],
      },
      storeList: [],
      tableData: [],
      //分页
      pageNo: 1,
      pageSize: 5,
      totalSize: 0,
      dealerLevel: [], //经销商级别,
      form1: {
        from_sn: "",
        dealer_name: "",
        from_level_id: "",
      },
      countrys: [],
      provinces: [],
      citys: [],
      areas: [],
      expense_num_list: [],
    };
  },
  methods: {
    //申报明细
    expensedetail(row) {
      this.salesman_id = row.id;
      this.selectDED = true;
    },
    //响应式更新申报数量
    updateMessage(id, expense_num) {
      this.expense_num_list[id] = this.expense_num_list[id] - expense_num;
      this.$set(
        this.expense_num_list,
        this.expense_num_list.length,
        this.expense_num_list[id]
      );
    },
    //请求列表数据
    onSearch() {
      this.loading = true;
      let beginstr = "",
        endstr = "";
      if (this.form.start) {
        beginstr = this.moment(this.form.start).format("YYYY-MM-DD");
      }
      if (this.form.end) {
        endstr = this.moment(this.form.end).format("YYYY-MM-DD");
      }
      this.$get("logistics_2", "/vstore/dealer_pc/dealerExpenseList", {
        lang: "",
        ...this.form,
        per_page: this.pageSize,
        page: this.pageNo,
        start_time: beginstr,
        end_time: endstr,
      })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.data;
          this.totalSize = res.data.total;
          this.expense_num_list = [];
          this.tableData.forEach((element, idx) => {
            this.expense_num_list[element.id] = element.expense_num;
          });
        })
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.onSearch();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.onSearch();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //申请报销
    confirm(row, temp) {
      this.$confirm("确认申请报销吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var url = "/vstore/dealer_pc/addDealerExpense";
          this.$get("logistics_2", url, {
            product_number: row.number,
          })
            .then((res) => {
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: "申报成功，等待上级报销",
                });
                this.onSearch();
              } else {
                this.$message({
                  type: "error",
                  message: "申报失败",
                });
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消报销",
          });
        });
    },
  },
  created() {
    this.onSearch();
  },
  components: {
    selectDealerExpenseDetail,
  },
};
</script>
<style lang="scss" scoped></style>
